<template>
  <div class="">
    <div v-if="returnMessage" class="msg_overlay text-center">
      <h1 :class="classMessage">
        <i
          class="bi bi-bell"
          style="font-size: 103px; display: block"
          :class="classMessage"
        ></i
        ><br />{{ returnMessage }}
      </h1>
    </div>

    <nav class="navbar sticky-top navbar-dark">
      <div class="container-fluid">
        <a class="navbar-brand"
          ><span style="font-size: 1.1rem">Participants sur site.</span>
          <h1 style="color: #fff !important">
            {{ total }}
          </h1></a
        >
      </div>
    </nav>
    <div
      class="
        container-fluid
        d-flex
        align-items-center
        justify-content-center
      "
      style="height: 91vh"
      :class="classMode"
    >
      <div class="row">
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn_myicon_success"
            id="readBarcode"
            @click="startScanner"
            v-if="editMode == null"
          >
            <i class="bi bi-upc-scan" style="font-size: 53px"></i>
          </button>
        </div>
        <div class="col-12 text-center mt-3">
          <p style="color: #fff !important">
            (Pour démarrer le scanner, cliquez ci-dessous)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editMode: null,
      openMode: null,
      query: "",
      showModal: false,
      typemodal: null,
      contentmodal: null,
      ModalMessage: null,
      classmodalMessage: null,
    };
  },

  components: {},
  props: [
    "Scans",
    "returnMessage",
    "classMessage",
    "classMode",
    "modeMessage",
    "total",
  ],
  computed: {
    filteruser: function () {
      return this.Scans.filter((s) =>
        s.registered_lastname.toLowerCase().includes(this.query.toLowerCase())
      );
    },
  },
  methods: {
    startScanner() {
      this.$emit("showScanner");
    },

    // toggleMode() {
    //   this.$emit("toggleThemode");
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>